/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import router from '@/router';
// services for new API
import apiLayer from '@/services/jApiLayer';
// services for old API
import apiPositionLayer from '@/services/jApiPositionLayer';

const state = {
  // Set default state(s) here
  position_layer_state: {
    detail_position_layer: null,
    created_position_layer: false,
    updated_position_layer: false,
    deleted_position_layer: false,
  },
};

const getters = {
  // Change value of state(s) with getter

};

const mutations = {
  showCreatedPositionLayer(state) {
    state.position_layer_state.created_position_layer =
      !state.position_layer_state.created_position_layer;
    router.push('/company/organization');
  },

  showUpdatedPositionLayer(state) {
    state.position_layer_state.updated_position_layer =
      !state.position_layer_state.updated_position_layer;
  },

  showDeletedPositionLayer(state) {
    state.position_layer_state.deleted_position_layer =
      !state.position_layer_state.deleted_position_layer;
  },

  showDetailPositionLayer(state, payload) {
    state.position_layer_state.detail_position_layer =
      payload.data;
  },
};

const actions = {
  // request API for getListLayer is on the jLayerList.vue, not here

  // create new project (API has been updated to new endpoint)
  async createPositionLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const createPositionLayer = await apiLayer.createLayer(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', createPositionLayer.message, { root: true });
      // trigger variable to change
      commit('showCreatedPositionLayer');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // detail layer
  async getDetailPositionLayer({ dispatch, commit }, data) {
    try {
      const getDetailPositionLayer = await apiPositionLayer.getDetailPositionLayer(data);
      commit('showDetailPositionLayer', getDetailPositionLayer);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // detail layer
  async updatePositionLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const updatePositionLayer = await apiPositionLayer.updatePositionLayer(data);
      commit('showUpdatedPositionLayer');
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updatePositionLayer.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // delete layer
  async deletePositionLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const deletePositionLayer = await apiPositionLayer.deletePositionLayer(data);
      commit('showDeletedPositionLayer');
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deletePositionLayer.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStorePositionLayer.js